import { Alert, Modal } from 'antd';
import Search from 'antd/lib/input/Search';
import { useEffect, useState } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';

import { TypedUseSelectorHook, useDispatch, useSelector } from 'react-redux';
import { AppDispatch, RootState } from '../../../app/store';

import { selectTheme, showSearchPopup, ThemeColor } from '../../../features/theme/themeSlice';
import { Game, GameProvider } from '../../../model/GameProvider';

import gameProviders from '../../../fakedata/gameProviders2.json';
import GameComponent from '../../../components/games/GameComponent';

const SearchModal: React.FC = () => {
	const intl = useIntl();
	const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;
	const theme = useAppSelector(selectTheme);
	const dispatch = useDispatch<AppDispatch>();
	const [searchText, setSearchText] = useState<string>('');
	const [game, setGames] = useState<Array<Game>>([]);
	const [filteredGames, setFilteredGames] = useState<Array<Game> | null>(null);

	useEffect(() => {
		if (searchText !== '') {
			setFilteredGames(game.filter(gi => gi.name.toLowerCase().startsWith(searchText.toLowerCase(), 0)));
		} else {
			setFilteredGames(game);
		}
	}, [searchText]);

	useEffect(() => {
		const glist: Array<Game> = [];
		gameProviders.forEach(g => {
			glist.push(...g.games);
		});
		setGames(glist);
		setFilteredGames(glist);
	}, []);

	return (
		<Modal
			key={'modal-search'}
			title={<FormattedMessage id="popup.search.game.title" />}
			className={`modal-search-game ${theme.theme == ThemeColor.dark ? 'dark' : 'light'}`}
			centered
			visible={theme.popupSearch}
			onOk={() => dispatch(showSearchPopup(false))}
			onCancel={() => dispatch(showSearchPopup(false))}
			footer={[
				<Alert
					message={intl.formatMessage({ id: 'popup.search.footer.alert', defaultMessage: 'Search the game' })}
				/>
			]}
		>
			<Search key={'search-text'} value={searchText} onChange={evt => setSearchText(evt.target.value)} />
			<div key={'game-list'} className="provider-games-list-container">
				<div className="provider-games-list">
					{filteredGames &&
						filteredGames.map((g, i) => {
							return (
								<GameComponent
									key={`${g.operator}-${i}`}
									title={intl.formatMessage({ id: g.name })}
									image={g.image}
									operator={g.operator}
									urlEndPoint={g.urlEndPoint}
									provider={g.provider}
									gameId={g.gameId}
									onClick={() => {
										dispatch(showSearchPopup(false));
									}}
								/>
							);
						})}
				</div>
			</div>
		</Modal>
	);
};

export default SearchModal;
